module.exports = __webpack_public_path__ + "img/t2-17.fb93d8d0.svg";